import PropertyType from '../Modifiers/PropertyType.js';

var ThemeBlockShadowValue = new PropertyType({
  name: 'BlockShadowValue',
  propertyFromApi: 'block-shadow-value',
  defaultValue: 'rgba(0, 0, 0, 0.2)'
}, 'theme');
var FormBlockShadowValue = new PropertyType({
  name: 'BlockShadowValue',
  propertyFromApi: 'block-shadow-value',
  defaultValue: 'rgba(0, 0, 0, 0.2)'
}, 'form');

export { FormBlockShadowValue, ThemeBlockShadowValue };
//# sourceMappingURL=BlockShadowValue.js.map
